import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Suivi } from "app/models/Suivi";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SuiviService {
  serveur_name = environment.serveur_name;
  host_name = environment.host_name;
  private suivisUrl = this.host_name+"/api/suivis";
  token: string;
  constructor(private http: HttpClient) {}
  recupererToutAbonnement(): Observable<Suivi[]> {
    return this.http.get<Suivi[]>(this.suivisUrl);
  }
  abonner(suivi: Object): Observable<Object> {
    return this.http.post<Suivi[]>(this.suivisUrl, suivi);
  }

  getUtilisateur(id: string) {
    return this.http.get(`${this.suivisUrl}/id/${id}`);
  }

  desabonner(id: string): Observable<any> {

    return this.http.delete(`${this.suivisUrl}/${id}`);
  }
  trouverParIdUtilisateurConnecte(idUtilisateurConnecte: string) {
    return this.http.get(
      `${this.suivisUrl}/idUtilisateurConnecte/${idUtilisateurConnecte}`
    );
  }
  trouverParIdAmiSuiv(idAmiSuivi: string) {

    return this.http.get(`${this.suivisUrl}/idAmiSuivi/${idAmiSuivi}`);
  }
  trouverParIdAmiSuivAndIdUtilisateurConnecte(
    idAmiSuiv: string,
    idUtilisateurConnecte: string
  ): Observable<Suivi[]> {
    return this.http.get<Suivi[]>(
      `${this.suivisUrl}/${idAmiSuiv}/${idUtilisateurConnecte}`
    );
  }
}
